import {
    Modal,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableHeader,
    TableRow,
} from '@ksyos/design-system';
import type { ThirdPartyMessageResult } from '@common/enums/thirdPartyMessageResult';
import { ManagerAuthorization } from '@common/enums';
import { NullableFormattedDatetime } from '@frontend/components/elements/NullableFormattedDatetime';
import { translateKey } from '@frontend/translate';
import { assertHasAuthorization } from '@frontend/utils/assertHasAuthorization';
import { useFetchItems } from '@frontend/utils/hooks/useFetchItems';

interface IThirdPartyMessagesResultModalProps {
    messageId: string;
    onClose: () => void;
}

interface IThirdPartyMessageResult {
    data: string;
    dateTime: Date;
    id: string;
    result: ThirdPartyMessageResult;
}

export function ThirdPartyMessageResultModal(props: IThirdPartyMessagesResultModalProps) {
    const [thirdPartymessageResults] = useFetchItems<IThirdPartyMessageResult>(
        `/api/thirdPartyMessagesResults/${props.messageId}`
    );

    assertHasAuthorization(ManagerAuthorization.thirdPartyMessages);

    return (
        <Modal
            isOpen
            onClose={() => props.onClose()}
            size="large"
        >
            <Modal.Header>{translateKey('processThirdPartyMessages.results')}</Modal.Header>
            <Modal.CloseButton />
            <Modal.Body>
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableHeader>{'dateTime'}</TableHeader>
                                <TableHeader>{'result'}</TableHeader>
                                <TableHeader>{'data'}</TableHeader>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {thirdPartymessageResults.map((result) => (
                                <TableRow key={result.id}>
                                    <TableCell>
                                        <NullableFormattedDatetime value={result.dateTime} />
                                    </TableCell>
                                    <TableCell>{result.result}</TableCell>
                                    <TableCell>{result.data}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Modal.Body>
            <Modal.Footer />
        </Modal>
    );
}
